<div class="integrations">
  <glxy-form-field [formGroup]="form">
    <mat-radio-group [formControl]="integrationFormControl" class="vertical-radio-group">
        @if (googleMeetContext$ | async; as googleMeetContext) {
          <ng-container [ngTemplateOutlet]="integration" [ngTemplateOutletContext]="googleMeetContext"></ng-container>
        }
        @if (zoomContext$ | async; as zoomContext) {
          <ng-container [ngTemplateOutlet]="integration" [ngTemplateOutletContext]="zoomContext"></ng-container>
        }
        @if (microsoftContext$ | async; as microsoftContext) {
          <ng-container [ngTemplateOutlet]="integration" [ngTemplateOutletContext]="microsoftContext"></ng-container>
        }
    </mat-radio-group>
  </glxy-form-field>
</div>

<ng-template #integration let-service="service" let-iconUrl="iconUrl" let-label="label" let-connected="connected">
  <div class="vertical-radio-item" (click)="setSelected(service)">
    <integrations-service-connection-status class="connection" [service]="service" [useAlternateStyling]="true">
      @if (connected) {
        <integrations-connect-element>
          <div class="container">
            <mat-radio-button [value]="service" [checked]="integrationFormControl.value === service">
              <div class="label-container">
                <div class="svg-container">
                  <img [src]="iconUrl" [alt]="label + ' icon'" class="integration-icon" />
                </div>
                <span>{{ label }}</span>
              </div>
              @if (service === googleService) {
                <glxy-hint class="recording-hint">{{
                  'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.CALENDAR.REQUIRED_FOR_RECORDING' | translate
                }}</glxy-hint>
              }
            </mat-radio-button>
          </div>
        </integrations-connect-element>
      } @else {
        <integrations-disconnect-element>
          <div class="container">
            <mat-radio-button [value]="service" [checked]="integrationFormControl.value === service">
              <div class="label-container">
                <div class="svg-container">
                  <img [src]="iconUrl" [alt]="label + ' icon'" class="integration-icon" />
                </div>
                <div class="disconnected-container">
                  <span>{{ label }}</span>
                </div>
              </div>
              @if (service === googleService) {
                <glxy-hint class="recording-hint">{{
                  'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.CALENDAR.REQUIRED_FOR_RECORDING' | translate
                }}</glxy-hint>
              }
            </mat-radio-button>
          </div>
        </integrations-disconnect-element>
      }
    </integrations-service-connection-status>
  </div>
</ng-template>
